import { Component, Input, OnInit } from '@angular/core';
import { MenuService } from '../../../services/menu.service';

@Component({
  selector: 'lib-recursive-menu',
  templateUrl: './recursive-menu.component.html',
  styleUrls: ['./recursive-menu.component.css']
})
export class RecursiveMenuComponent implements OnInit {

  @Input() settings: any;
  @Input() menuItem: any;
  @Input() index: number;

  constructor(
    public menuService: MenuService
  ) { }

  flatMenu: any[];
  childMenu: any[];

  ngOnInit() {
    this.flatMenu = [...this.menuService.menuData[this.settings.selectedCategory].flatMenu];
    this.childMenu = [];
    this.childMenu = this.flatMenu.filter(i => i.parentId === this.menuItem.id);
  }


}

